import React, { useState } from "react";
import {
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  styled,
} from "@mui/material";
import CustomButton from "../Components/Button";
import { useMutation, useQuery, useQueryClient } from "react-query";
import {
  getGuestData,
  getRelationData,
  updateGuestStatus,
} from "./mutations/guestCreation";
import Loader from "../Components/Loader";
import OrganizationGuestComponent from "../Components/OrganizationGuestComponent";
import { handleToastMsg } from "../Components/Toast";
import RelationGuestComponent from "../Components/RelationGuestComponent";
import { formatDate, formatTime } from "../../utils/formatDate";
import CustomDivider from "../Components/CustomDivider"

export const Card = styled(Grid)`
  border: 1px solid #000;
  border-radius: 15px;
  padding: 50px;
  text-align: center;
  cursor: pointer;
  background: #fff;
  // box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.12);
  box-shadow: 1px 1px rgba(16, 24, 40, 0.12);
`;

function GuestComponent() {
  const [stepper, setStepper] = useState("OPTIONS"); // options, create, queue
  const { mutate: statusMutate, isLoading: statusLoader } =
    useMutation(updateGuestStatus);
  const queryClient = useQueryClient();

  const {
    data: guestOrgData,
    isLoading: orgLoading,
    isFetching,
  } = useQuery("get-org-data", () => getGuestData(), {
    onSuccess: (res) => {
      console.log({ res });
    },
    refetchOnMount: true,
  });

  const {
    data: guestRelationData,
    isLoading: resLoading,
    isFetching: relationFetching,
  } = useQuery("get-relation-data", () => getRelationData(), {
    refetchOnMount: true,
  });

  console.log({ guestOrgData, guestRelationData });

  const updateStatus = (id) => {
    statusMutate(id, {
      onSuccess: (res) => {
        queryClient.invalidateQueries("get-relation-data");
        queryClient.invalidateQueries("get-org-data");
        handleToastMsg("Removed successfully", "success");
      },
      onError: (err) => {
        handleToastMsg(err.message, "error");
      },
    });
  };

  if (
    orgLoading ||
    resLoading ||
    isFetching ||
    relationFetching ||
    statusLoader
  )
    return <Loader />;

  console.log(formatTime("2024-03-14T02:44:34.608Z"), "updatedTime");

  return (
    <Grid container justifyContent={"center"}>
      <Grid item xs={12} style={{ paddingTop: '2%', paddingBottom: '2%' }}>
        <h4 style={{ textAlign: "center" }}>Guest / விருந்தினர்</h4>
        <CustomDivider />
      </Grid>
      {stepper === "OPTIONS" && (
        <Grid container justifyContent={"space-between"} xs={10} py={5}>
          <Grid item mb={4}>
            <Card onClick={() => setStepper("SUB_OPTIONS")}>
              Add Guest / விருந்தினரைச் சேர்க்கவும்
            </Card>
          </Grid>
          <Grid item>
            <Card onClick={() => setStepper("QUEUE")}>
              View Guest / விருந்தினரைப் பார்க்கவும்
            </Card>
          </Grid>
        </Grid>
      )}
      {stepper === "SUB_OPTIONS" && (
        <>
          <Grid container justifyContent={"space-between"} xs={8} py={5}>
            <Grid item mb={4} xs={12} md={5}>
              <Card onClick={() => setStepper("ORGANIZATION")}>
                Organization / அமைப்பு
              </Card>
            </Grid>
            <Grid item xs={12} md={5}>
              <Card onClick={() => setStepper("RELATION")}>
                Relation / உறவு
              </Card>
            </Grid>
          </Grid>
        </>
      )}
      {stepper === "ORGANIZATION" && (
        <>
          <OrganizationGuestComponent
            isNotMobile={true}
            setStepper={setStepper}
          />
        </>
      )}
      {stepper === "RELATION" && (
        <>
          <RelationGuestComponent isNotMobile={true} setStepper={setStepper} />
        </>
      )}
      {stepper === "QUEUE" && (
        <>
          <Grid item container>
            <Grid item xs={12} textAlign={"center"}>
              <h4>Officals</h4>
            </Grid>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>Date / தேதி</TableCell>
                  <TableCell align="right">Name / பெயர்</TableCell>
                  <TableCell align="right">Organization / அமைப்பு</TableCell>
                  <TableCell align="center">In time / உள்ளே</TableCell>
                  <TableCell align="center">Image</TableCell>
                  <TableCell align="right"></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {guestOrgData && guestOrgData.length > 0 ? (
                  guestOrgData.map((row) => (
                    <TableRow
                      key={row.id}
                      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                    >
                      <TableCell component="th" scope="row">
                        {formatDate(row.inDate)}
                      </TableCell>
                      <TableCell align="center">{row.visitorName}</TableCell>
                      <TableCell align="center">{row.organization}</TableCell>
                      <TableCell align="center">
                        {formatTime(row.inTime)}
                      </TableCell>
                      <TableCell align="center">
                        <img
                          src={row.image}
                          alt="img"
                          width={150}
                          height={150}
                          style={{ objectFit: "contain" }}
                        />
                      </TableCell>
                      <TableCell align="right">
                        <CustomButton onClick={() => updateStatus(row.id)}>
                          Out / வெளியே
                        </CustomButton>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <h4>No data found</h4>
                )}
              </TableBody>
            </Table>
          </Grid>
          <Grid item container>
            <Grid item xs={12} textAlign={"center"}>
              <h4>Employee Visitors</h4>
            </Grid>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>Date / தேதி</TableCell>
                  <TableCell align="right">Name / பெயர்</TableCell>
                  <TableCell align="right">Relationship / உறவு</TableCell>
                  <TableCell align="center">In time / உள்ளே</TableCell>
                  <TableCell align="center">Image</TableCell>
                  <TableCell align="right"></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {guestRelationData && guestRelationData.length > 0 ? (
                  guestRelationData.map((row) => (
                    <TableRow
                      key={row.id}
                      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                    >
                      <TableCell component="th" scope="row">
                        {formatDate(row.inDate)}
                      </TableCell>
                      <TableCell align="center">{row.visitorName}</TableCell>
                      <TableCell align="center">{row.relationship}</TableCell>
                      <TableCell align="center">
                        {formatTime(row.inTime)}
                      </TableCell>
                      <TableCell align="center">
                        <img
                          src={row.image}
                          alt="img"
                          width={150}
                          height={150}
                          style={{ objectFit: "contain" }}
                        />
                      </TableCell>
                      <TableCell align="right">
                        <CustomButton onClick={() => updateStatus(row.id)}>
                          Out / வெளியே
                        </CustomButton>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <h4>No data found</h4>
                )}
              </TableBody>
            </Table>
          </Grid>
        </>
      )}
    </Grid>
  );
}

export default GuestComponent;
